module.exports = __webpack_public_path__ + "montserrat-light-webfont.6225f3ca44b830908330.woff";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/~/@okta/okta-signin-widget/dist/font/montserrat-light-webfont.woff
// module id = ../../../../@okta/okta-signin-widget/dist/font/montserrat-light-webfont.woff
// module chunks = 11